import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Form from "./Form";

const AccessDenied = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto redirect to home after 8 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 8000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Form
      title="Access Denied"
      showCancel={false}
      showSubmit={false}
      footerLinks={
        <div style={{ marginTop: "20px" }}>
          <Link to="/">Go Home</Link>
        </div>
      }
    >
      <p> Privileges required to access this page</p>

      <p>Redirecting to home page ...</p>
    </Form>
  );
};

export default AccessDenied;
